import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../Contexts/GlobalContext";
import { useNavigate } from "react-router-dom";
import { hideNav } from "../Utlils";
import { FaExclamationCircle, FaArrowRight } from "react-icons/fa";

const WarningBar = () => {
  const navigate = useNavigate();
  const { user, setSnackbar } = useGlobalContext();
  const [shouldDisplay, setShouldDisplay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!user.organizationName) {
        setShouldDisplay(true);
      } else {
        setShouldDisplay(false);
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [user?.organizationName]);
  if (
    hideNav.some((data) => window.location.href.includes(data)) ||
    !shouldDisplay ||
    !Object.keys(user || {})?.length
  ) {
    return null;
  }

  return (
    <div
      className={`w-full bg-red-50 border-l-4 border-red-400 rounded-md shadow-sm my-3 ${
        hideNav?.some((data) => window.location.href?.includes(data))
          ? "hidden"
          : ""
      }`}
    >
      <div className="px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="flex-shrink-0">
            <FaExclamationCircle className="text-red-500" size={20} />
          </div>
          <div className="flex-1">
            <h3 className="text-[#333] text-[14px] font-[600] mb-0.5">
              Organization Details Missing
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">
              Your organization name is not set. Please add it to continue using the platform.
            </p>
          </div>
        </div>
        <button
          className="flex-shrink-0 bg-[#0226BE] text-white px-5 py-2 text-[13px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors flex items-center gap-2 whitespace-nowrap"
          onClick={() => {
            if (user?.role === "admin") {
              navigate("/profile/my-profile");
            } else {
              setSnackbar({
                open: true,
                msg: "Only admin can add this details",
                severity: "warning",
              });
            }
          }}
        >
          Update Profile
          <FaArrowRight size={12} />
        </button>
      </div>
    </div>
  );
};

export default WarningBar;
